/* Yard & Union — product behaviours. Loaded on every page (quick-add modals need the size guard too).
   1. Size-guide dialog
   2. Size selection guard: no size is preselected; Add to cart stays disabled and Shop Pay is guarded until a size
      is chosen. Any attempt to proceed shows "Select a size…" and points at the size picker.
   3. Sticky mobile add-to-cart
   No dependencies. */
(function () {
  'use strict';

  var MSG = 'Select a size to add this to your cart.';

  // ---- 1. size guide dialog -------------------------------------------------
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-yu-open]');
    if (open) {
      var dlg = document.getElementById(open.getAttribute('data-yu-open'));
      if (dlg && typeof dlg.showModal === 'function') dlg.showModal();
      return;
    }
    if (e.target.closest('[data-yu-close]')) {
      var d = e.target.closest('dialog');
      if (d) d.close();
      return;
    }
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('yu-sizeguide')) e.target.close();
  });

  // ---- 2. size selection guard ----------------------------------------------
  // The server (snippets/yu-size-state) decides whether a size is still required and stamps
  // data-yu-size-required on <variant-selects>. Dawn swaps that element on every option change,
  // so the attribute is always fresh. This code only keeps the surrounding UI in step with it.
  function needsSize(pi) {
    var vs = pi && pi.querySelector('variant-selects');
    return !!vs && vs.getAttribute('data-yu-size-required') === 'true';
  }

  function sizeFieldset(pi) {
    var sets = pi.querySelectorAll('variant-selects fieldset');
    for (var i = 0; i < sets.length; i++) {
      var lg = sets[i].querySelector('legend');
      if (lg && /size/i.test(lg.textContent)) return sets[i];
    }
    return sets[0] || null;
  }

  function syncGuard(pi) {
    var needs = needsSize(pi);
    var buttons = pi.querySelector('.product-form__buttons');
    if (buttons) buttons.classList.toggle('is-guarded', needs);

    var pay = pi.querySelector('.yu-paybtn');
    if (pay) { if (needs) pay.setAttribute('inert', ''); else pay.removeAttribute('inert'); }

    // The variant id input is disabled server-side while a size is required (so nothing can be submitted).
    // Dawn only updates its value on selection, so re-enable it here — but only if WE disabled it.
    var idIn = pi.querySelector('input[name="id"].product-variant-id');
    if (idIn) {
      if (needs) {
        if (!idIn.disabled) { idIn.disabled = true; idIn.setAttribute('data-yu-disabled', '1'); }
      } else if (idIn.getAttribute('data-yu-disabled') === '1') {
        idIn.disabled = false;
        idIn.removeAttribute('data-yu-disabled');
        // let Shopify's accelerated checkout pick up the now-valid variant
        if (window.Shopify && window.Shopify.PaymentButton && window.Shopify.PaymentButton.init) {
          try { window.Shopify.PaymentButton.init(); } catch (err) { /* non-fatal */ }
        }
      }
    }
    if (!needs) {
      var fs = sizeFieldset(pi);
      if (fs) fs.classList.remove('yu-size-missing');
    }
  }

  function promptSize(pi) {
    if (!pi) return;
    var form = pi.querySelector('product-form');
    if (form && typeof form.handleErrorMessage === 'function') form.handleErrorMessage(MSG);
    var fs = sizeFieldset(pi);
    if (!fs) return;
    fs.classList.remove('yu-size-missing');
    void fs.offsetWidth; // restart the attention animation
    fs.classList.add('yu-size-missing');
    var r = fs.getBoundingClientRect();
    if (r.top < 0 || r.bottom > window.innerHeight) fs.scrollIntoView({ block: 'center', behavior: 'smooth' });
    var first = fs.querySelector('input[type="radio"]');
    if (first) first.focus({ preventScroll: true });
  }

  // Disabled buttons swallow clicks, so a transparent overlay (shown only while guarded) catches the attempt.
  document.addEventListener('click', function (e) {
    var p = e.target.closest('[data-yu-size-prompt]');
    if (!p) return;
    var pi = p.closest('product-info');
    if (needsSize(pi)) { e.preventDefault(); e.stopPropagation(); promptSize(pi); }
  }, true);

  document.addEventListener('change', function (e) {
    var pi = e.target.closest && e.target.closest('product-info');
    if (pi && e.target.matches('variant-selects input[type="radio"], variant-selects select')) {
      var fs = sizeFieldset(pi);
      if (fs) fs.classList.remove('yu-size-missing');
    }
  });

  function syncAll() { document.querySelectorAll('product-info').forEach(syncGuard); }

  var raf = 0;
  // setTimeout (not rAF): rAF is paused in background tabs, and this state must never lag behind the DOM.
  function schedule() { if (!raf) raf = setTimeout(function () { raf = 0; syncAll(); syncStickies(); }, 0); }

  // Also watch `disabled`: Dawn's ProductForm force-enables the variant id input on init, which would undo the
  // server-side disable (and unguard Shop Pay) depending on load order. Re-assert it whenever that happens.
  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'data-yu-size-required']
  });
  document.addEventListener('product-info:loaded', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule); else schedule();

  // ---- 3. sticky add-to-cart -------------------------------------------------
  // Dawn re-renders parts of the product form, so never hold element references: look them up each time.
  function stickyFor(bar) {
    var sid = bar.getAttribute('data-section-id');
    return {
      sid: sid,
      main: function () { return document.getElementById('ProductSubmitButton-' + sid); },
      price: function () { return document.getElementById('price-' + sid); },
      btn: bar.querySelector('[data-yu-sticky-button]'),
      out: bar.querySelector('[data-yu-sticky-price]')
    };
  }

  function syncSticky(bar) {
    var s = stickyFor(bar);
    var mb = s.main();
    if (!mb || !s.btn) return;
    var pi = mb.closest('product-info');
    var needs = needsSize(pi);
    var label = mb.querySelector('span');
    var text = (label ? label.textContent : mb.textContent).replace(/\s+/g, ' ').trim();
    s.btn.textContent = needs ? 'Select a size' : (text || 'Add to cart');
    // While a size is required the bar is visually disabled but stays clickable so it can explain why.
    s.btn.setAttribute('aria-disabled', needs ? 'true' : 'false');
    s.btn.classList.toggle('is-needs-size', needs);
    s.btn.disabled = !needs && (mb.disabled || mb.getAttribute('aria-disabled') === 'true');
    var pe = s.price();
    if (pe && s.out) {
      var el = pe.querySelector('.price-item--sale') || pe.querySelector('.price-item--regular') || pe;
      var p = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (p) s.out.textContent = p;
    }
  }

  function toggleSticky(bar) {
    var mb = stickyFor(bar).main();
    if (!mb) return;
    var visible = mb.getBoundingClientRect().bottom < 0; // main button has scrolled up out of view
    bar.classList.toggle('is-visible', visible);
    bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    var b = stickyFor(bar).btn;
    if (b) b.tabIndex = visible ? 0 : -1;
  }

  function syncStickies() { document.querySelectorAll('[data-yu-sticky]').forEach(function (b) { syncSticky(b); toggleSticky(b); }); }

  function initSticky(bar) {
    if (bar.__yuInit) return;
    bar.__yuInit = true;
    var s = stickyFor(bar);
    // Dawn's slide-in animation leaves a transform on ancestors, which breaks position:fixed.
    // Re-parent to <body> so the bar is truly fixed to the viewport.
    document.querySelectorAll('body > [data-yu-sticky][data-section-id="' + s.sid + '"]').forEach(function (old) { if (old !== bar) old.remove(); });
    if (bar.parentElement !== document.body) document.body.appendChild(bar);

    s.btn.addEventListener('click', function () {
      var mb = s.main();
      if (!mb) return;
      var pi = mb.closest('product-info');
      if (needsSize(pi)) { promptSize(pi); return; }
      mb.click(); // proxy to the real button so Dawn handles validation, the cart drawer and errors
    });

    var ticking = 0;
    window.addEventListener('scroll', function () { if (!ticking) ticking = requestAnimationFrame(function () { ticking = 0; toggleSticky(bar); }); }, { passive: true });
    window.addEventListener('resize', function () { toggleSticky(bar); });
    syncSticky(bar);
    toggleSticky(bar);
  }

  function bootSticky() { document.querySelectorAll('[data-yu-sticky]').forEach(initSticky); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootSticky); else bootSticky();
  document.addEventListener('shopify:section:load', bootSticky);
  new MutationObserver(function () { bootSticky(); }).observe(document.body || document.documentElement, { childList: true });
})();
